module.exports = __webpack_public_path__ + "16f2ad6715d477f923fc5b122b083e3b.png";